import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useSubscription } from '@/hooks/useSubscription';

interface SubscriberGuardProps {
  children: ReactNode;
}

/**
 * Requires an authenticated user AND an active subscription.
 * - Not authed -> /signin (with from=)
 * - Authed but no active sub -> /welcome (tier picker)
 */
export default function SubscriberGuard({ children }: SubscriberGuardProps) {
  const { user, loading: authLoading } = useAuth();
  const { isActive, loading: subLoading } = useSubscription();
  const location = useLocation();

  if (authLoading || subLoading) {
    return <Splash label="Verifying subscription" />;
  }
  if (!user) {
    return <Navigate to="/signin" replace state={{ from: location.pathname }} />;
  }
  if (!isActive) {
    return <Navigate to="/welcome" replace />;
  }
  return <>{children}</>;
}

function Splash({ label }: { label: string }) {
  return (
    <div className="app">
      <div className="main" style={{ display: 'grid', placeItems: 'center', minHeight: '60vh' }}>
        <div style={{ textAlign: 'center', color: 'var(--text-muted)' }}>
          <div className="eyebrow" style={{ marginBottom: 8 }}>{label}</div>
          <div style={{ fontFamily: 'var(--mono)', fontSize: 11, letterSpacing: '0.18em' }}>
            ◊ ◊ ◊
          </div>
        </div>
      </div>
    </div>
  );
}
